// @ts-ignore - eventually should upgrade this pkg to the TS version
import escapeStringRegexp from 'escape-string-regexp';

/**
 * Generate a RegEx that matches any of the strings in the argument array.
 * @param  {String[]} stringList strings to match
 * @return {RegExp}
 */
export default function matchStrings(stringList: string[]): string {
  return stringList.map(x => escapeStringRegexp(x)).join('|');
}
